<div class="search-field">
  <form
    class="search-field__container"
    (keydown.enter)="$event.preventDefault()"
    (keydown.escape)="clearSearchbox()"
  >
    <mat-form-field class="search-field__input" floatLabel="auto">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        type="text"
        [placeholder]="placeholderText"
        aria-label="label"
        [matAutocomplete]="auto"
        data-test="search-field__input"
        [formControl]="searchField"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="getOptionSelectName"
        (optionSelected)="selectOption($event)"
      >
        @for (option of autoCompleteOptions | async; track option) {
          <mat-option [value]="option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
      <button
        mat-icon-button
        matSuffix
        (click)="clearSearchbox()"
        [style.opacity]="(isLoading$ | async) === true || !searchField.value ? 0 : 1"
        data-test="search-field__clear"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
    @if (isLoading$ | async) {
      <div class="spinner-container">
        <mat-progress-spinner mode="indeterminate" diameter="15"></mat-progress-spinner>
      </div>
    }
  </form>
</div>
